// Angular
import { Component } from '@angular/core';
import { Router } from '@angular/router';

// Angular Material
import { MatDialog } from '@angular/material/dialog';

// localforage
import * as localforage from 'localforage';

// services
import { DrawerService } from '@app/services/drawer/drawer.service';

@Component({
  selector: 'oh-close-open-house-dialog',
  templateUrl: './close-open-house-dialog.component.html',
  styleUrls: ['./close-open-house-dialog.component.scss'],
})
export class CloseOpenHouseDialogComponent {
  constructor(private router: Router, private dialog: MatDialog, private drawerService: DrawerService) {}

  public async confirm() {
    await localforage.removeItem('oh-selected-open-house');
    await localforage.removeItem('oh-active-user');
    this.drawerService.dismiss();
    this.dialog.closeAll();
    this.router.navigate(['/open-house-select']);
  }

  public cancel() {
    this.dialog.closeAll();
  }
}
